import React, { useEffect, useState } from "react";
import { HowToReg, PersonOff } from "@mui/icons-material";

const Present1Widget = ({ widget, onValueUpdate }) => {
  const [isPresent, setIsPresent] = useState(false);

  useEffect(() => {
    if (widget?.items?.$w1) {
      setIsPresent(widget.items.$w1.value === "present");
    }
  }, [widget]);

  const getStatusText = () => {
    return isPresent ? "present" : "clear";
  };

  const getPresenceIcon = () => {
    return isPresent ? (
      <HowToReg style={{ fontSize: "1.2rem" }} />
    ) : (
      <PersonOff style={{ fontSize: "1.2rem" }} />
    );
  };

  return (
    <div
      className="flex items-center justify-center gap-2 w-full border rounded-2xl transition-colors duration-300"
      style={{
        height: "40px",
        borderColor: isPresent ? "hsl(var(--primary))" : "hsl(var(--border))",
      }}
    >
      {getPresenceIcon()}
      <span className="text-[0.925rem] font-medium capitalize whitespace-nowrap overflow-hidden text-ellipsis max-w-full">
        {getStatusText()}
      </span>
    </div>
  );
};

export default Present1Widget;
